import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService, Breadcrumb } from 'angular-crumbs';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { PreloaderComponent } from './preloader/preloader.component';
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    Location, {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  load: boolean | undefined

  constructor(private titleService: Title, private _avRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService, public router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.load = true;
      /** START : Code to Track Page View  */
      gtag('event', 'page_view', {
        page_path: event.urlAfterRedirects
      })
      /** END */
    })

  }

  ngOnInit(): void {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';
      console.log('Online...');
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! You are not connected to internet';
      this.connectionStatus = 'offline';
      console.log('Offline...');
    }));
  }
  onActivate(_event: any) {
    window.scroll(0, 0);
  }
  // private createTitle(routesCollection: Breadcrumb[]) {
  //   const title = "ThreatLabZ";
  //   const titles = routesCollection.filter((route) => route.displayName);

  //   if (!titles.length) { return title; }

  //   const routeTitle = this.titlesToString(titles);
  //   return `${title}${routeTitle}`;
  // }

  // private titlesToString(titles: any[]) {
  //   return titles.reduce((prev, curr) => {
  //     return `${prev} | ${curr.displayName}`;
  //   }, '');
  // }

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
